exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2VltW-vThrJMw3UkosRIcR {\n  display: grid;\n  height: 100vh;\n  background: #075189;\n  font-size: 45px;\n  color: white;\n  text-align: center;\n  align-content: center;\n  justify-content: center; }\n", ""]);

// Exports
exports.locals = {
	"maintenanceContainer": "_2VltW-vThrJMw3UkosRIcR"
};